import { TmcContextService } from './../../../common/tmc-context.service';
import { TaskType } from './../model/task-type.enum';
import { ProcessingStatus } from './../model/processing-status';
import { TaskRelevance } from './../model/task-relevance.enum';
import { Task } from './../model/task';
import { TranslationService } from '@sdbn/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-task-assignment',
  templateUrl: './task-assignment-dialog.component.html',
  styleUrls: ['./task-assignment-dialog.component.scss']
})
export class TaskAssignmentDialogComponent implements OnInit {

  taskType = TaskType;
  taskRelevance = TaskRelevance;

  tasks: Task[] = [];

  relevanceOptions: TaskRelevance[] = [];
  relevanceOptionsForMessages: TaskRelevance[] = [];
  relevanceOptionsForAttrubteChange: TaskRelevance[] = [];

  processingStatusOptions: ProcessingStatus[] = [];

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<TaskAssignmentDialogComponent>,
    private tmcContextService: TmcContextService,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    if (data.processingStatusModel != null) {
      for (const model of this.tmcContextService.getYardConfiguration().processingStatusModels) {
        if (model.key === this.data.processingStatusModel) {
          for (const status of model.status) {
            const statusOption = new ProcessingStatus();
            statusOption.key = status.key;
            statusOption.dictionaryKey = status.dictionaryKey;
            this.processingStatusOptions.push(statusOption);
          }
        }
      }
    }

    this.tasks = data.taskAssignmentOptions.tasks;

    let manual = new Array<TaskRelevance>();
    let automatically = new Array<TaskRelevance>();

    manual.push(TaskRelevance[TaskRelevance.OPTIONAL]);
    manual.push(TaskRelevance[TaskRelevance.ON_ENTRANCE]);
    manual.push(TaskRelevance[TaskRelevance.ON_LEAVE]);
    manual.push(TaskRelevance[TaskRelevance.BEFORE_RETRIEVE]);
    manual.push(TaskRelevance[TaskRelevance.AFTER_RETRIEVE]);
    manual.push(TaskRelevance[TaskRelevance.BEFORE_FINISH]);
    if (this.processingStatusOptions != null && this.processingStatusOptions.length > 0) {
      manual.push(TaskRelevance[TaskRelevance.BEFORE_PROCESSING_STATUS]);
    }

    // Messages haben sowohl automatische als auch nicht automatische auslöser
    automatically.push(TaskRelevance[TaskRelevance.AUTOMATICALLY_ON_RETRIEVE]);
    automatically.push(TaskRelevance[TaskRelevance.AUTOMATICALLY_ON_FINISH_TRANSPORT]);
    automatically.push(TaskRelevance[TaskRelevance.AUTOMATICALLY_ON_ATTACH_TRUCK]);
    automatically.push(TaskRelevance[TaskRelevance.AUTOMATICALLY_WHEN_AVAILABLE]);
    if (this.processingStatusOptions != null && this.processingStatusOptions.length > 0) {
      automatically.push(TaskRelevance[TaskRelevance.AUTOMATICALLY_ON_PROCESSING_STATUS]);
    }

    this.relevanceOptions = manual;
    this.relevanceOptionsForMessages = manual.concat(automatically);
    this.relevanceOptionsForAttrubteChange = automatically;

  }

  ngOnInit() {

  }

  public cancelDialog() {
    this.dialogRef.close(null);
  }

  public confirm() {
    this.dialogRef.close(this.tasks.filter(t => t.selected));
  }

}
